import React from "react";
import { Tag } from "antd";

export const B2BSTATUS = {
  1: <Tag color="blue">Pending</Tag>,
  2: <Tag color="green">Accepted</Tag>,
  3: <Tag color="red">Rejected</Tag>,
};
